import { lazy } from 'react';
import { createBrowserRouter, createHashRouter } from 'react-router-dom';

import { isDesktopRuntime } from '@/lib/runtime';
import { ProtectedLayout, RootRedirect, RouterSuspense } from '@/app/router/route-guards';

const AuthPage = lazy(() => import('@/features/auth/page'));
const AcceptInvitePage = lazy(() => import('@/features/auth/accept-invite-page'));
const DashboardPage = lazy(() => import('@/features/dashboard/page'));
const CompaniesPage = lazy(() => import('@/features/companies/page'));
const CompanyDetailPage = lazy(() => import('@/features/companies/company-detail-page'));
const DocumentsPage = lazy(() => import('@/features/documents/page'));
const NotesPage = lazy(() => import('@/features/notes/page'));
const TasksPage = lazy(() => import('@/features/tasks/page'));
const CalendarPage = lazy(() => import('@/features/calendar/page'));
const InsightsPage = lazy(() => import('@/features/ai/page'));
const ActivityPage = lazy(() => import('@/features/activity/page'));
const SettingsPage = lazy(() => import('@/features/settings/page'));
const SearchPage = lazy(() => import('@/features/search/page'));
const ProfilePage = lazy(() => import('@/features/profile/page'));

const routeTree = [
  {
    path: '/',
    element: <RouterSuspense />,
    children: [
      { index: true, element: <RootRedirect /> },
      { path: 'auth', element: <AuthPage /> },
      { path: 'auth/accept-invite', element: <AcceptInvitePage /> },
      {
        element: <ProtectedLayout />,
        children: [
          { path: 'dashboard', element: <DashboardPage /> },
          { path: 'companies', element: <CompaniesPage /> },
          { path: 'companies/:companyId', element: <CompanyDetailPage /> },
          { path: 'documents', element: <DocumentsPage /> },
          { path: 'notes', element: <NotesPage /> },
          { path: 'tasks', element: <TasksPage /> },
          { path: 'calendar', element: <CalendarPage /> },
          { path: 'insights', element: <InsightsPage /> },
          { path: 'activity', element: <ActivityPage /> },
          { path: 'search', element: <SearchPage /> },
          { path: 'settings', element: <SettingsPage /> },
          { path: 'profile', element: <ProfilePage /> },
        ],
      },
    ],
  },
];

export const router = isDesktopRuntime() ? createHashRouter(routeTree) : createBrowserRouter(routeTree);
